import { useState, useEffect, useCallback, useRef } from 'react';
import { confirmacaoResend, confirmacaoSalvar } from '../../../api/autenticacao';
import { aplicaCoresOneShell } from '../../../services/authentication/auth';

const useConfirmacaoLoginHook = ({ logar, tokenCodUser, setTela, setMessageLogin }) => {
  aplicaCoresOneShell();
  const inputRefs = useRef([]);
  const [open, setOpen] = useState(false);
  const [isPending, setPending] = useState(false);
  const [contador, setContador] = useState(0);
  const [msgCodigoVerificacao, setMsgCodigoVerificacao] = useState('');
  const [bloqueiaBotaoConfirmar, setBloqueiaBotaoConfirmar] = useState(true);

  const handleFormSubmit = (values, form) => {
    setPending(true);
    values.TOKENVALIDACAO = values.TOKENVALIDACAO.replaceAll(' ', '').toUpperCase();
    values.token_user = tokenCodUser;

    confirmacaoSalvar(values)
      .then(retorno => {
        const retMFA = retorno.data;
        if (retMFA.home) {
          setTela('login');
          logar();
        } else if (retMFA.login) {
          if (retMFA.message) {
            setMessageLogin(retMFA.message);
          }
          setTela('login');
        } else if (retMFA.message) {
          setMsgCodigoVerificacao(retMFA.message);
        }
      })
      .catch(() => {
        setMsgCodigoVerificacao('Ocorreu um erro interno, favor contatar o suporte');
      })
      .finally(() => {
        setPending(false);
        form.setSubmitting(false);
      });
  };

  const reenviarToken = () => {
    modalReenviar(false);
    setPending(true);
    const params = { token_user: tokenCodUser };
    const countSec = 60;
    setContador(countSec);

    confirmacaoResend(params)
      .then(retorno => {
        const retMFA = retorno.data;
        if (retMFA.login) {
          if (retMFA.message) setMessageLogin(retMFA.message);
          setTela('login');
        } else if (retMFA.message) {
          setMsgCodigoVerificacao(retMFA.message);
        }
      })
      .catch(() => {
        setMsgCodigoVerificacao('Ocorreu um erro interno, favor contatar o suporte');
      })
      .finally(() => setPending(false));
  };

  const limpaMsgErro = event => {
    setMsgCodigoVerificacao('');
    if (event.target.value !== '') {
      setBloqueiaBotaoConfirmar(false);
    } else {
      setBloqueiaBotaoConfirmar(true);
    }
  };

  useEffect(() => {
    if (contador <= 0) return;

    const intervalId = setInterval(() => {
      setContador(prev => (prev > 1 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [contador]);

  const validateInputs = useCallback(values => {
    const errors = {};
    if (!values.TOKENVALIDACAO.trim()) {
      errors.TOKENVALIDACAO = 'Informe o código.';
    } else {
      const value = values.TOKENVALIDACAO.replaceAll(' ', '').trim();
      if (value.length !== 6) {
        errors.TOKENVALIDACAO = 'Digite o código enviado';
      }
    }
    return errors;
  }, []);

  const modalReenviar = acao => setOpen(acao);

  const formatTimer = seconds => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  return {
    open,
    isPending,
    contador,
    msgCodigoVerificacao,
    bloqueiaBotaoConfirmar,
    validateInputs,
    handleFormSubmit,
    modalReenviar,
    reenviarToken,
    limpaMsgErro,
    formatTimer,
    inputRefs
  };
};

export default useConfirmacaoLoginHook;
